import { render, staticRenderFns } from "./EducationTraining.vue?vue&type=template&id=0d9aad62&scoped=true"
import script from "./EducationTraining.vue?vue&type=script&lang=js"
export * from "./EducationTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9aad62",
  null
  
)

export default component.exports